import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SessionService } from '@edl-development/edl-common';
import { StateService } from '@uirouter/core';
import { EdlTooltipIcon } from 'src/app/components/common-components/enum/edl-tooltip-icon.enum';
import { DOMAIN_FILTER_CHIPS } from 'src/app/components/domain-navigation/constants/domain-filter-chips.constants';
import { InitializeEditModePolicy } from 'src/app/components/observation-comments/enums/initialize-edit-mode-policy.enum';
import { GenericType } from 'src/app/model/base/edl-generic-type.model';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';
import { ObservationTypes } from 'src/app/model/enum/observation-types.enum';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';
import { Domain } from 'src/app/model/enum/observations/domain.enum';
import { NTPEObservationStatus } from 'src/app/model/enum/observations/ntpe/ntpe-observation-status.enum';
import { Subdomain } from 'src/app/model/enum/observations/subdomain.enum';
import { DomainLookup } from 'src/app/model/interfaces/DomainLookup.interface';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';
import { NtpeModel } from 'src/app/model/observation/ntpe/ntpe.model';
import { ObservationSectionPermissionsDTO } from 'src/app/model/observation/observation-section-permissions-dto.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { NTPE_GETTING_STARTED_LINK } from 'src/app/properties/observations/ntpe/ntpe.constants';
import { DEFAULT_RUBRIC_LANGUAGE_LINK } from 'src/app/properties/observations/rubric/rubric.constants';
import { ResourceData } from 'src/app/services/resource/resource.service';

@Component({
    selector: 'app-ntp-section-three-midyear-update',
    templateUrl: './section-three-midyear-update.component.html',
    styleUrls: ['./section-three-midyear-update.component.scss']
})
export class SectionThreeMidyearUpdateComponent implements OnInit {
    @Input() readOnly: boolean = true;
    @Input() resourceFile: ResourceData = {};
    @Input() permissions?: ObservationSectionPermissionsDTO;

    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() observationDetails?: NtpeModel;
    @Input() filterType?: DomainFilterType = DomainFilterType.FOCUS_AREAS;
    @Input() currentRubricComponent?: Subdomain = Subdomain.CONTENT_KNOWLEDGE;

    @Output() navigate = new EventEmitter<number>();
    @Output() approve = new EventEmitter();
    @Output() save = new EventEmitter<any>();
    @Output() submit = new EventEmitter();
    @Output() onFocusChange = new EventEmitter<{ subdomain?: SubdomainLookup, focused?: boolean }>();
    @Output() onDomainNativation = new EventEmitter<{ subdomain?: SubdomainLookup }>();

    DOMAIN_FILTER_CHIPS = DOMAIN_FILTER_CHIPS;
    DomainFilterType = DomainFilterType;
    InitializeEditModePolicy = InitializeEditModePolicy;
    public observationType?: GenericType;
    ObservationTypeValues = ObservationTypeValues;

    public rubricLanguageLink: string = DEFAULT_RUBRIC_LANGUAGE_LINK;
    public gettingStartedLink: string = NTPE_GETTING_STARTED_LINK;
    EdlTooltipIcon = EdlTooltipIcon;
    @Input() form!: UntypedFormGroup;
    @Input() domains: DomainLookup[] = [];

    @Input() focusAreas: string[] = [];
    isSupervisor = false;
    isTargetUser = false;

    constructor(private sessionService: SessionService,
        private stateService: StateService) { }

    ngOnInit(): void {
        this.observationType = ObservationTypes.GetObservationType(this.observationSummary?.itemType);

        const currentUser = this.sessionService.user;
        this.isSupervisor = currentUser?.UserID == this.observationDetails?.evaluatingUserId;
        this.isTargetUser = currentUser?.UserID == this.observationDetails?.targetUserId;

        this.rubricLanguageLink = this.resourceFile['RubricPDF.Text'] ?? DEFAULT_RUBRIC_LANGUAGE_LINK;
    }

    onApprove = () => this.approve.emit();
    onSaveClick(event: any) {
        this.save.emit(event);
    }
    onSubmit() { this.submit.emit(); }

    onDomainNavigationClick = ({ subdomain }: { subdomain?: SubdomainLookup }) =>
        this.onDomainNativation.emit({ subdomain: subdomain });

    onComponentFocusClick({ domain, subdomain, isFocusArea }: { domain?: Domain, subdomain?: SubdomainLookup, isFocusArea?: boolean }) {
        this.onFocusChange.emit({ subdomain: subdomain, focused: isFocusArea })
    }

    isFocusArea(subdomain: SubdomainLookup) {
        return this.focusAreas?.includes(subdomain.Key);
    }

    canNotifyOfComment(): boolean {
        return (this.permissions?.canComment
            && (this.observationDetails?.status ?? -1) == NTPEObservationStatus.PendingApproval)
            ?? false
    }
}
